import { useEffect, useState } from "react";
import axios from "axios";
import { BASE_URL } from "../components/config/config";
import { useSelector } from "react-redux";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";

function Payments() {
  const globalState = useSelector((state) => state.AdminReducer);
  const [transactions, setTransactions] = useState([]);

  useEffect(() => {
    const { centerDetailsPopulated } = globalState;
    const { phone } = centerDetailsPopulated?.personal_details;

    const fetchData = async () => {
      try {
        const response = await axios.post(
          `${BASE_URL}center/center-all-transaction`,
          {
            mobile_number: phone?.mobile_number,
          }
        );
        setTransactions(response.data.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    if (phone?.mobile_number) {
      fetchData();
    }
  }, [globalState]);

  return (
    <div>
      <h2>Transactions</h2>
      <TableContainer component={Paper}>
        <Table aria-label="transactions table">
          <TableHead>
            <TableRow>
              <TableCell>Date</TableCell>
              <TableCell>Transaction ID</TableCell>
              <TableCell>Amount</TableCell>
              <TableCell>Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {transactions.map((transaction) => (
              <TableRow key={transaction._id}>
                <TableCell>
                  {new Date(transaction.createdAt).toLocaleString("en-IN", {
                    timeZone: "Asia/Kolkata",
                    month: "long",
                    day: "numeric",
                    hour: "numeric",
                    minute: "numeric",
                    second: "numeric",
                    hour12: true,
                  })}
                </TableCell>
                <TableCell>{transaction.transactionId}</TableCell>
                <TableCell>{transaction.amount}</TableCell>
                <TableCell>{transaction.status}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}

export default Payments;
